import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox, Field } from '@cleartrip/bento'
import ModalHeader from '../UserProfileModalHeader'
import Dropdown from 'components/Dropdown'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg'
import { ReactComponent as SuperCoins } from 'assets/icons/SuperCoins.svg'
import { ReactComponent as SellDesign } from 'assets/icons/sell.svg'
import { ReactComponent as AccountCircleDesign } from 'assets/icons/account_circle.svg'
import { getCookie, isEmpty } from 'utils/browserHelper'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'
import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'
import OtpBox from './otpBox'
import { MOBILE_COUNTRY_CODES, POPULAR_MOBILE_COUNTRY } from 'constants/mobileCountryCodes'
import { Divider } from '@cleartrip/bento/components/Divider'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import { ReactComponent as Email } from 'assets/icons/email.svg'
import { getAbTestConfig, sendOtpForSignIn } from 'api/flights/results'
import { errorConfig } from './errorConfig'
import { resolveKeysInObjectsArrays } from 'utils/browserHelper'
import ModalHeaderNew from '../UserProfileModalHeaderNew'
import Clevertap from 'analytics'
import { ReactComponent as WalletLogin } from 'assets/icons/WalletLogin.svg'
import { ReactComponent as OffersLogin } from 'assets/icons/OffersLogin.svg'
import BannerSlider from 'components/BannerSlider'


import GetOtpButton from 'lib/Login/GetOtpButton'

const LoginWithMobileNew = ({
    mobileAndCountryCodeItem,
    setPageName,
    validateMobileHandler,
    isMobileValid,
    handleLinkClick,
    toggle,
    mobile,
    countryCode,
    setMobileValid,
    showCloseButton,
    disableEmailLogin,
    userData,
    email,
    superCoinLogin,
    initialRender,
    setInitialRender,
    abLogin = 'a',
    abInline ='a'
}) => {
    const animationDefaultState = { isAnimate: false, direction: 'right', isFadeIn: false }
    const [loading, setLoading] = useState(false)
    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
    const [apiError, setApiError] = useState('')
    const [countDown, setCountDown] = useState(0)
    const [retriesLeft, setRetriesLeft] = useState(4)
    const [animationParams, setAnimationParams] = useState(animationDefaultState)
    const bannerAnimationRef = useRef()
    const animatedClass = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'px-8': 'px-8'
    })

    const animatedClassNew = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'pxNew-8': 'pxNew-8'
    })

    const getOtpValue = () => {
        const otp = otpDigits.join('')
        return otp
    }
    const getOtpPress = useRef()
    let errorInfo = 'fs-inherit c-inherit pl-2'
    const disabled = getOtpValue().length != 6
    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]

    const checkHiFiveFlow = () => {
        const retVal =
            pathname &&
            pathname.length > 2 &&
            pathname[1] === 'ref' &&
            !isEmpty(pathname[2]) &&
            pathname[2] != 'null' &&
            pathname[2] != 'undefined'
        return retVal
    }

    const isHiFiveFlow = checkHiFiveFlow()
    useEffect(() => {
        ClevertapEvent({
            actionName: 'Login_Signup_modal_opened',
            actionType: 'Button',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            currentPage: pagePath
        })
    }, [])

    useEffect(() => {
        let OutsideClickHandler = event => {
            if (!bannerAnimationRef.current.contains(event.target)) {
                setInitialRender(true)
                toggle()
            }
        }
        document.addEventListener('mousedown', OutsideClickHandler)
        return () => {
            document.removeEventListener('mousedown', OutsideClickHandler)
        }
    })

    useEffect(() => {
        const timeOut = setTimeout(() => {
            setInitialRender(false)
        }, 1000)
        return () => {
            clearTimeout(timeOut)
        }
    }, [])
    return (
        <>
            <div className={`${initialRender ? 'bannerAnimation p-relative' : ''}`}>
                <div ref={bannerAnimationRef} className="d-flex">
                    <div
                        className="o-hidden d-flex flex-column brLogin-4 slick-dots"
                        style={{
                            width: '410px',
                            height: '437px'
                        }}
                    >
                        {abLogin === 'a' && <BannerSlider />}  
                        {abLogin === 'b' && <img src="https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_410,h_437,dpr_2/offermgmt/bbdJson/Desktop_Banner.png" className="h-100" />}

                        
                    </div>
                    <div
                        className="bg-white  o-hidden d-flex flex-column brLoginNew-4"
                        style={{
                            width: '400px',
                            height: '437px'
                        }}
                    >
                        <div
                            className={`${animatedClass} d-flex flex-1 flex-column`}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    // getOtpPress()
                                    if (getOtpPress?.current) {
                                        getOtpPress.current.fire()
                                      }
                                }
                            }}
                        >
                            <ModalHeaderNew toggle={toggle} showCloseButton={showCloseButton} />
                            <OfflineToast page="proceed" />
                            {apiError && (
                                <>
                                    <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                                        <InfoIcon className="c-white" height={16} width={16} />
                                        <span data-testid="signinError" className={errorInfo}>
                                            {apiError}
                                        </span>
                                    </div>
                                    <Spacer className="pt-4" />
                                </>
                            )}
                            <div className="d-flex flex-1 flex-between flex-column">
                                <div>
                                    {mobileAndCountryCodeItem}
                                    <Spacer className={'mt-6'} />

                                    {/* <div>
                                        <Button
                                            className="h-10 bg-black-500 hover:bg-black-500 "
                                            disabled={!disabled}
                                            size="md"
                                            type="secondary"
                                            busy={loading}
                                            full
                                            onClick={() => getOtp()}
                                        >
                                            <span className={`${!disabled ? 'c-grey-30' : ''} fs-3 fw-500`}>
                                                {'Get OTP'}
                                            </span>
                                        </Button>
                                    </div> */}
                                    
                                    <GetOtpButton 
                                        ref={getOtpPress}
                                        mobile={mobile}
                                        validateMobileHandler={validateMobileHandler}
                                        countryCode={countryCode}
                                        setPageName={setPageName}
                                        superCoinLogin={superCoinLogin}
                                        abLogin={abLogin}
                                        abInline={abInline}
                                        setApiError={setApiError}
                                        />

                                    <div className="mt-3 fs-12 fw-400 c-neutral-grey ta-center">
                                        We no more support email based login. You can now login via mobile number & link
                                        email to access your account.
                                    </div>
                                </div>
                                <div className="mb-5">
                                    <Divider className="bc-grey-10" />
                                    <div className="mt-5 d-flex flex-column flex-middle">
                                        <span>
                                            <span className="fs-2 c-grey-70">
                                                By continuing, you agree to Cleartrip's
                                            </span>
                                            <span
                                                className="fs-2 fw-500 c-blue c-pointer"
                                                onClick={() => handleLinkClick('privacy-policy')}
                                            >
                                                {' '}
                                                privacy policy
                                            </span>{' '}
                                            <span className="fs-2 c-grey-70">&</span>{' '}
                                        </span>
                                        <span>
                                            <span
                                                className="fs-2 fw-500 c-blue c-pointer"
                                                onClick={() => handleLinkClick('terms-of-service')}
                                            >
                                                terms of use.
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginWithMobileNew
